<template>
    <div class="view-requests">
        <div class="section-title v-request">Search Jobs</div>
        <div class="">
            <div class="field padded-bottom">
                <div class="control">
                    <div class="columns">
                        <div class="column is-5">
                            <label>From (Service Date)</label>
                            <div class='formfield'>
                                <jqueryui-datepicker :passedId="startDate" :value="formData.start_date" :vuexStore="store" :vuexAction="updateAction" :vuexFormTab="itemToUpdate"></jqueryui-datepicker>
                            </div>
                        </div>
                        <div class="column is-5">
                            <label>To (Service Date)</label>
                            <div class='formfield'>
                                <jqueryui-datepicker :passedId="endDate" :value="formData.end_date" :vuexStore="store" :vuexAction="updateAction" :vuexFormTab="itemToUpdate"></jqueryui-datepicker>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="field padded-bottom">
                <div class="control">
                    <div class="columns">
                        <div class="column is-5">
                            <label>Status</label>
                            <div class='formfield'>
                                <div class='custom-select status-dropdown'>
                                    <div class="dropdown">
                                        <div class="dropdown-toggle" type="button" id="drop-down-menu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" v-html="formData.status_name">
                                        </div>
                                        <div data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                            <b class="custom-caret"></b>
                                        </div>
                                        <div class="dropdown-menu" aria-labelledby="drop-down-menu">
                                            <div v-for="(option, index) in options" :key="index" @click.prevent='setActiveStatus(option)'>
                                                <div class='custom-option' v-html="option.name"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="field padded-bottom">
                <div class="control">
                    <div class="columns">
                        <div class="column is-8">
                            <label>Keyword Search</label>
                            <div class='formfield'>
                                <input class="input" type="text" :value="formData.keywords" @change="update('keywords', $event.target.value)" placeholder="Job number, patient name, etc"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="field">
                <div class="control">
                    <div class="columns">
                        <div class="column find-buttons">
                            <div>
                            <button @click.prevent="findRequests" class="button v-button gray-button is-link">Search</button>
                            </div>
                            <div>
                            <button @click.prevent="clearSearch"class="button v-button tertiary-button">Clear All</button>
                            </div>
                            <div class='custom-select export-button tertiary-button'>
                                <div class="dropdown">
                                    <div class="dropdown-toggle" type="button" id="drop-down-menu" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Export
                                    </div>
                                    <div data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <b class="custom-caret"></b>
                                    </div>
                                    <div class="dropdown-menu" aria-labelledby="drop-down-menu">
                                        <div>
                                            <div id="export-csv" class='custom-option'>CSV</div>
                                        </div>
                                        <div>
                                            <div id="export-print" class='custom-option'>Print</div>
                                        </div>
                                        <div>
                                            <div id="export-pdf" class='custom-option'>Save as PDF</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    data () {
        return {
            all: [
                {
                    id: '0',
                    abbr_full_name: 'All'
                }
            ],
            options: [
                {
                    value: '0',
                    name: "&nbsp;All"
                },
                {
                    value: '1',
                    name: "<span class='dot scheduled'></span> Scheduled"
                },
                {
                    value: '4',
                    name: "<span class='dot cancelled'></span> Cancelled"
                },
                {
                    value: '2',
                    name: "<span class='dot completed'></span> Completed"
                }
            ],
            store: 'filter',
            updateAction: 'updateSelectedData',
            startDate: 'start_date',
            endDate: 'end_date',
            itemToUpdate: 'dates'
        }
    },

    computed: {
        ...mapState('filter', {
            formData: state => state.formData,
        }),
    },

    methods: {
        findRequests(){
            VueStore.dispatch('filter/findRequests');
        },

        clearSearch(){
            VueStore.dispatch('filter/clear');
        },

        setActiveStatus(option){
            //console.log(option);
            if(option.value != '0'){
                this.update('request_status_id', option.value)
            // When all is set, remove key from filterData
            } else {
                VueStore.dispatch('filter/removeKey', 'request_status_id');
            }
            this.update('status_name', option.name)

        },
        update: function (key, value) {
            // dispatch action to update vuex
            VueStore.dispatch('filter/updateSelectedData', {formTab: 'none', key: key, value: value});
        },
    },

    mounted(){
    },

    created(){

    }

}

</script>

<style>
.status-dropdown .dropdown-menu{
    height: 140px !important;
}
</style>
